import { useEffect, useState } from 'react';
import {
  getTrackingConsent,
  TRACKING_CONSENT_CHANGED_EVENT,
  TRACKING_CONSENT_KEY,
  TrackingConsent,
} from './trackingConsent';

/**
 * The current consent choice. It follows a change in this tab (the consent bar) and in another tab
 * of the same origin (music24.com or another /app tab, through the `storage` event).
 */
export function useTrackingConsent(): TrackingConsent | null {
  const [consent, setConsent] = useState<TrackingConsent | null>(() => getTrackingConsent());

  useEffect(() => {
    const refresh = (): void => setConsent(getTrackingConsent());
    const onStorage = (event: StorageEvent): void => {
      if (event.key === TRACKING_CONSENT_KEY || event.key === null) {
        refresh();
      }
    };
    window.addEventListener(TRACKING_CONSENT_CHANGED_EVENT, refresh);
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener(TRACKING_CONSENT_CHANGED_EVENT, refresh);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  return consent;
}
